import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';

const getColor = (timer: number) => {
    const oneDay = 24 * 60 * 60 * 1000;
    const oneHour = 60 * 60 * 1000;

    if (timer > oneDay) return Colors.green;
    if (timer < oneDay && timer > oneHour) return Colors.orange;
    return Colors.red;
};

export const Timer = styled.span<{ timer: number }>`
    color: ${({ timer }) => getColor(timer)};
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    font-family: 'Assistant', sans-serif;
    font-weight: 700;
    font-size: 40px;
    /* font-weight: 600; 
    font-size: 18px;*/
    line-height: 20px;

    @media screen and (max-width: 767px) {
        font-size: 35px;
    }

    @media screen and (max-width: 575px) {
        font-size: 30px;
    }

    @media screen and (max-width: 375px) {
        font-size: 20px;
    }
`;
